const currentSurveyReducer = (state = {}, action) => {
    switch (action.type) {
      case "SET_CURRENT_SURVEY":
        return action.payload;
      default:
        return state;
    }
  }
  export default currentSurveyReducer;